import { Component, OnInit } from '@angular/core';
import { LatestTalentService } from './latest-talent.service';

@Component({
  selector: 'app-latest-talent',
  templateUrl: './latest-talent.component.html',
  styleUrls: ['./latest-talent.component.scss']
})
export class LatestTalentComponent implements OnInit {
  talent: any;

  constructor(private latestTalentService: LatestTalentService) {}

  ngOnInit(): void {
    this.latestTalentService.getLatestTalent().subscribe((response: any) => {
      this.talent = response?.data?.[0]?.attributes;
    });
  }
}
